<!-- New Icon for progress 1 -->
<svg
  *ngIf="progress == 1"
  width="31"
  height="31"
  viewBox="0 0 31 31"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M31 15.5C31 24.0591 24.0591 31 15.5 31C6.9409 31 0 24.0591 0 15.5C0 6.9409 6.9409 0 15.5 0C24.0591 0 31 6.9409 31 15.5Z"
    fill="#64D082"
  />
  <path
    d="M22.1309 9.75446L12.71 19.1865L9.4643 15.9501C8.85856 15.3462 7.87834 15.3469 7.27384 15.952C6.6681 16.5577 6.66872 17.5404 7.27508 18.1455L11.6163 22.4762C12.2221 23.0807 13.2029 23.0795 13.8074 22.4744L24.3238 11.9455C24.9283 11.3398 24.9283 10.359 24.3232 9.75384C23.7175 9.14872 22.736 9.14872 22.1309 9.75446Z"
    fill="white"
  />
</svg>

<!-- Old Icon for progress 1 -->
<!-- <svg
  *ngIf="progress == 1"
  width="22"
  height="22"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="2" y="2" width="18" height="18" rx="9" fill="white" />
  <path
    d="M6 10.2308L9.5 14L16 7"
    stroke="#009900"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg> -->

<!-- Old Icon for progress 1 -->
<!-- <svg
  *ngIf="progress == 1"
  width="25"
  height="25"
  viewBox="19 20 43 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <circle cx="40.5" cy="40.5" r="20.5" fill="#FAFAFA" />
    <path
      d="M40 29.5C47.0154 29.5 52.5 34.7356 52.5 40.9537C52.5 45.716 49.3061 49.8804 44.6413 51.5918C43.8635 51.8771 43.4643 52.7389 43.7497 53.5166C44.035 54.2944 44.8968 54.6935 45.6745 54.4082C51.3686 52.3192 55.5 47.129 55.5 40.9537C55.5 32.8636 48.4486 26.5 40 26.5C39.1716 26.5 38.5 27.1716 38.5 28C38.5 28.8284 39.1716 29.5 40 29.5Z"
      fill="#60F2A6"
    />
    <path
      d="M40 29.5C33.6437 29.5 28.5 34.633 28.5 40.9537C28.5 45.7837 31.503 49.9223 35.7617 51.6049C36.5322 51.9093 36.91 52.7807 36.6056 53.5512C36.3012 54.3216 35.4298 54.6995 34.6593 54.395C29.2991 52.2772 25.5 47.0613 25.5 40.9537C25.5 32.9661 31.9969 26.5 40 26.5C40.8284 26.5 41.5 27.1716 41.5 28C41.5 28.8284 40.8284 29.5 40 29.5Z"
      fill="#60F2A6"
    />
    <path
      d="M40.0267 46.0409C39.8544 46.0409 39.688 45.9725 39.5632 45.8507L36.7108 42.9983C36.4553 42.7428 36.4553 42.3298 36.7108 42.0743C36.9663 41.8187 37.3793 41.8187 37.6348 42.0743L39.994 44.4334L46.189 37.35C46.4267 37.0796 46.8397 37.0499 47.1101 37.2876C47.3805 37.5253 47.4102 37.9383 47.1725 38.2087L40.5169 45.815C40.3981 45.9517 40.2287 46.0319 40.0475 46.0379C40.0415 46.0409 40.0326 46.0409 40.0267 46.0409ZM37.1743 46.0409C37.0079 46.0409 36.8385 45.9785 36.7108 45.8507L33.8584 42.9983C33.6029 42.7428 33.6029 42.3298 33.8584 42.0743C34.1139 41.8187 34.5269 41.8187 34.7824 42.0743L37.6348 44.9266C37.8904 45.1822 37.8904 45.5952 37.6348 45.8507C37.51 45.9785 37.3407 46.0409 37.1743 46.0409ZM39.789 43.0696C39.6375 43.0696 39.483 43.0161 39.3611 42.9092C39.0878 42.6715 39.061 42.2585 39.2987 41.9881L43.3396 37.353C43.5773 37.0796 43.9903 37.0529 44.2607 37.2906C44.5341 37.5283 44.5608 37.9413 44.3231 38.2116L40.2822 42.8468C40.1515 42.9924 39.9702 43.0696 39.789 43.0696Z"
      fill="#60F2A6"
    />
  </g>
</svg> -->

<svg
  *ngIf="progress == 0"
  width="25"
  height="25"
  viewBox="19 20 43 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <circle cx="40.5" cy="40.5" r="20.5" fill="#FAFAFA" />
    <path
      d="M36.9516 45.9667C36.7692 45.9664 36.59 45.9185 36.4317 45.8279C36.0752 45.6259 35.8535 45.2337 35.8535 44.808V36.1921C35.8535 35.7652 36.0752 35.3742 36.4317 35.1722C36.5938 35.079 36.7779 35.0311 36.9649 35.0334C37.1518 35.0358 37.3347 35.0883 37.4944 35.1855L44.858 39.5933C45.0115 39.6895 45.138 39.8232 45.2257 39.9816C45.3134 40.1401 45.3594 40.3183 45.3594 40.4995C45.3594 40.6806 45.3134 40.8588 45.2257 41.0173C45.138 41.1758 45.0115 41.3094 44.858 41.4056L37.4932 45.8146C37.3298 45.9134 37.1426 45.966 36.9516 45.9667Z"
      fill="#525FE5"
    />
  </g>
</svg>

<svg
  *ngIf="progress > 0 && progress < 1"
  width="25"
  height="25"
  viewBox="19 20 43 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g>
    <circle cx="40.5" cy="40.5" r="20.5" fill="#FAFAFA" />
    <path
      d="M41 29.5C47.3563 29.5 52.5 34.633 52.5 40.9537C52.5 45.7837 49.497 49.9223 45.2383 51.6049C44.4678 51.9093 44.09 52.7807 44.3944 53.5512C44.6988 54.3216 45.5702 54.6995 46.3407 54.395C51.7009 52.2772 55.5 47.0613 55.5 40.9537C55.5 32.9661 49.0031 26.5 41 26.5C40.1716 26.5 39.5 27.1716 39.5 28C39.5 28.8284 40.1716 29.5 41 29.5Z"
      fill="#DEE6EB"
    />
    <path
      [attr.fill]="color"
      d="M41 29.5C33.9846 29.5 28.5 34.7356 28.5 40.9537C28.5 45.716 31.6939 49.8804 36.3587 51.5918C37.1365 51.8771 37.5357 52.7389 37.2503 53.5166C36.965 54.2944 36.1032 54.6935 35.3255 54.4082C29.6314 52.3192 25.5 47.129 25.5 40.9537C25.5 32.8636 32.5514 26.5 41 26.5C41.8284 26.5 42.5 27.1716 42.5 28C42.5 28.8284 41.8284 29.5 41 29.5Z"
    />
    <path
      d="M40.5001 42.6564C41.1968 42.6564 41.7616 42.0916 41.7616 41.3949C41.7616 40.6982 41.1968 40.1333 40.5001 40.1333C39.8033 40.1333 39.2385 40.6982 39.2385 41.3949C39.2385 42.0916 39.8033 42.6564 40.5001 42.6564Z"
      fill="#FD8469"
    />
    <path
      d="M44.7051 42.6564C45.4019 42.6564 45.9667 42.0916 45.9667 41.3949C45.9667 40.6982 45.4019 40.1333 44.7051 40.1333C44.0084 40.1333 43.4436 40.6982 43.4436 41.3949C43.4436 42.0916 44.0084 42.6564 44.7051 42.6564Z"
      fill="#FD8469"
    />
    <path
      d="M36.295 42.6564C36.9917 42.6564 37.5565 42.0916 37.5565 41.3949C37.5565 40.6982 36.9917 40.1333 36.295 40.1333C35.5983 40.1333 35.0334 40.6982 35.0334 41.3949C35.0334 42.0916 35.5983 42.6564 36.295 42.6564Z"
      fill="#FD8469"
    />
  </g>
</svg>
